export default __webpack_public_path__ + "static/17-14423dffc59fab52c42a58501bff5e32.webp";